import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

/**
 * 🔹 Payload para crear/actualizar
 */
export interface PesvDesplazamientosPayload {
  n_documento: string;
  fecha: string;
  conductor_id?: number | null;
  vehiculo_id?: string | null;
  origen: string;
  destino: string;
  ruta?: string | null;
  hora_salida_programada?: string | null;
  hora_llegada_programada?: string | null;
  hora_salida_real?: string | null;
  hora_llegada_real?: string | null;
  motivo?: string | null;
  kilometraje_inicial?: number | null;
  kilometraje_final?: number | null;
  estado?: number;
  observaciones?: string | null;
}

/**
 * 🔹 Entidad
 */
export interface PesvDesplazamientos {
  id?: number;
  n_documento: string;
  fecha: string;
  conductor_id?: number | null;
  vehiculo_id?: string | null;
  origen: string;
  destino: string;
  ruta?: string | null;
  hora_salida_programada?: string | null;
  hora_llegada_programada?: string | null;
  hora_salida_real?: string | null;
  hora_llegada_real?: string | null;
  motivo?: string | null;
  kilometraje_inicial?: number | null;
  kilometraje_final?: number | null;
  estado: number;
  observaciones?: string | null;
  fechaCreacion?: string;
  fechaModificacion?: string;
}

/**
 * 🔹 Respuesta genérica
 */
export interface PesvDesplazamientosResponse {
  id?: number;
  message?: string;
  error?: string;
  data?: any;
  [key: string]: any;
}

@Injectable({
  providedIn: "root",
})
export class PesvDesplazamientosService {
  private readonly apiUrl = `${environment.apiUrl}/api/pesv_desplazamientos`;

  constructor(private http: HttpClient) {}

  /**
   * Obtener todos los desplazamientos
   */
  getAll(): Observable<PesvDesplazamientos[]> {
    return this.http.get<PesvDesplazamientos[]>(this.apiUrl, {
      withCredentials: true,
    });
  }

  /**
   * Obtener desplazamiento por ID
   */
  getById(id: number): Observable<PesvDesplazamientos> {
    return this.http.get<PesvDesplazamientos>(
      `${this.apiUrl}/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  getByIdRiesgo(id: number): Observable<PesvDesplazamientos> {
    return this.http.get<PesvDesplazamientos>(
      `${this.apiUrl}/${id}/riesgo`,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Crear desplazamiento
   */
  create(
    payload: PesvDesplazamientosPayload
  ): Observable<PesvDesplazamientosResponse> {
    return this.http.post<PesvDesplazamientosResponse>(
      this.apiUrl,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Actualizar desplazamiento
   */
  update(
    id: number,
    payload: Partial<PesvDesplazamientosPayload>
  ): Observable<PesvDesplazamientosResponse> {
    return this.http.put<PesvDesplazamientosResponse>(
      `${this.apiUrl}/${id}`,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Eliminar desplazamiento
   */
  remove(id: number): Observable<any> {
    return this.http.delete<any>(
      `${this.apiUrl}/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Inactivar desplazamiento
   */
  inactivar(id: number): Observable<PesvDesplazamientosResponse> {
    return this.http.put<PesvDesplazamientosResponse>(
      `${this.apiUrl}/${id}/inactivar`,
      {},
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Activar desplazamiento
   */
  activar(id: number): Observable<PesvDesplazamientosResponse> {
    return this.http.put<PesvDesplazamientosResponse>(
      `${this.apiUrl}/${id}/activar`,
      {},
      {
        withCredentials: true,
      }
    );
  }
}